import React from 'react';

import './style.scss';

import Navbar from './navbar';
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const LandingHero = () => (
  <StaticQuery
    query={graphql`
      query {
        placeholderImage: file(relativePath: { eq: "landing-hero.png" }) {
          childImageSharp {
            fluid(maxWidth: 1200) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => <Img fluid={data.placeholderImage.childImageSharp.fluid} />}
  />
)

const Header = ({ siteTitle }) => (
	<section className="hero gradientBg is-fullheight-with-navbar">
		<Navbar />
		<div className="hero-body">
			<div className="container center">
				<article className="media">
					<div className="media-content">
						<div className="content">
							<h1 className="is-uppercase is-size-1 has-text-white center">
								Own Your Business Operations
							</h1>
							<p className="subtitle has-text-white is-size-3 center">
								Proc.Works puts you in control of your business operations with custom business objects
							</p>
							<LandingHero />
						</div>
					</div>
				</article>
			</div>
		</div>
	</section>
);

export default Header;
